<div style="display: flex; flex-direction: column; justify-content: space-around">
  <div style="overflow-y: auto; max-height: 500px">{{data.msg}}</div>
  <div style="display: flex; flex-direction: row; justify-content: flex-end;">
    <button mat-raised-button color="accent" (click)="dailogRef.close(false)">Close</button>
  </div>
</div>
